import en from './en.json'
import da from './da.json'
import de from './de.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector';

const DETECTION_OPTIONS = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage']
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, da: { translation: da }, de: { translation: de } },
    fallbackLng: 'en',
    detection: DETECTION_OPTIONS,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    },
  })

export default i18n
